import React, { useLayoutEffect, useRef, useEffect, useState } from "react";
import {
  Input,
  Card,
  CardBody,
  CardTitle,
  Button,
  FormGroup,
  FormFeedback,
  Spinner,
} from "reactstrap";
import { Helmet } from "react-helmet-async";
import { createTemplate, updateTemplate } from "../../utils/services/rsvp";
import { getUrlFiles } from "../../utils/services/files";
import SweetAlert from "react-bootstrap-sweetalert";
import { useLocation, useNavigate } from "react-router-dom";
import ReactDOMServer from "react-dom/server";
import FormMounted from "../AboutEvent/rsvp/FormMounted";
//redux
import { connect } from "react-redux";
import { getAllForms } from "../../utils/services/rsvp";
import blocksBasic from "grapesjs-blocks-basic";
import webpage from "grapesjs-preset-webpage";
import newsletter from "grapesjs-preset-newsletter";

// V2 — Sidebar em React (painéis Conteúdo / Estilos / Camadas modernos).
import SidebarTabs from "./panels/SidebarTabs";
import EditorTopbar from "./panels/EditorTopbar";
import { EditorProvider } from "./panels/EditorContext";
import { buildPreviewDoc } from "../Templates/previewDoc";

// Feature flag interna do V2: topbar moderna (botões React) vs. topbar
// legada (botões do editor.Panels do GrapesJS).
// true  = usa a topbar nova (moderna, coesa com a sidebar).
// false = mantém a topbar antiga do GrapesJS.
// Reverter = trocar para false.
const USE_MODERN_TOPBAR = true;

import "./main.scss";
import "../../assets/scss/app.scss";

const categoryIcons = {
  Componentes: "fa fa-puzzle-piece",
  Elementos: "fa fa-cube",
  Formulários: "fa fa-user-circle",
  Templates: "fa fa-file-code-o",
};

// Tradução PT-BR para os menus/abas do editor GrapesJS.
// Baseado em grapesjs/src/i18n/locale/pt.js (não incluído no bundle da CDN).
// Para reverter: remover esta constante e a chave `i18n` do editorConfig.
const ptLocale = {
  assetManager: {
    addButton: "Adicionar imagem",
    inputPlh: "http://caminho/para/a/imagem.jpg",
    modalTitle: "Selecionar imagem",
    uploadTitle: "Solte os arquivos aqui ou clique para enviar",
  },
  domComponents: {
    names: {
      "": "Bloco",
      wrapper: "Corpo",
      text: "Texto",
      comment: "Comentário",
      image: "Imagem",
      video: "Vídeo",
      label: "Label",
      link: "Link",
      map: "Mapa",
      tfoot: "Rodapé da tabela",
      tbody: "Corpo da tabela",
      thead: "Cabeçalho da tabela",
      table: "Tabela",
      row: "Linha da tabela",
      cell: "Célula da tabela",
      section: "Seção",
      body: "Corpo",
    },
  },
  deviceManager: {
    device: "Dispositivo",
    devices: {
      desktop: "Desktop",
      tablet: "Tablet",
      mobileLandscape: "Celular, modo panorâmico",
      mobilePortrait: "Celular, modo retrato",
    },
  },
  panels: {
    buttons: {
      titles: {
        preview: "Pré-visualização",
        fullscreen: "Tela cheia",
        "sw-visibility": "Ver componentes",
        "export-template": "Ver código",
        "open-sm": "Abrir gerenciador de estilos",
        "open-tm": "Configurações",
        "open-layers": "Abrir gerenciador de camadas",
        "open-blocks": "Abrir blocos",
      },
    },
  },
  selectorManager: {
    label: "Classes",
    selected: "Selecionado",
    emptyState: "- Estado -",
    states: {
      hover: "Hover",
      active: "Click",
      "nth-of-type(2n)": "Par/Ímpar",
    },
  },
  styleManager: {
    empty: "Selecione um elemento para usar o gerenciador de estilos",
    layer: "Camada",
    fileButton: "Imagens",
    sectors: {
      general: "Geral",
      layout: "Disposição",
      typography: "Tipografia",
      decorations: "Decorações",
      extra: "Extra",
      flex: "Flex",
      dimension: "Dimensão",
    },
    properties: {
      float: "Float",
      display: "Exibição",
      position: "Posição",
      top: "Topo",
      right: "Direita",
      left: "Esquerda",
      bottom: "Inferior",
      width: "Largura",
      height: "Altura",
      "max-width": "Largura Max.",
      "max-height": "Altura Max.",
      margin: "Margem",
      "margin-top": "Margem Superior",
      "margin-right": "Margem a Direita",
      "margin-left": "Margem a Esquerda",
      "margin-bottom": "Margem Inferior",
      padding: "Padding",
      "padding-top": "Padding Superior",
      "padding-left": "Padding a Esquerda",
      "padding-right": "Padding a Direita",
      "padding-bottom": "Padding Inferior",
      "font-family": "Tipo de letra",
      "font-size": "Tamanho da fonte",
      "font-weight": "Espessura da fonte",
      "letter-spacing": "Espaço entre letras",
      color: "Cor",
      "line-height": "Altura da linha",
      "text-align": "Alinhamento do texto",
      "text-shadow": "Sombra do texto",
      "text-shadow-h": "Sombra do texto: horizontal",
      "text-shadow-v": "Sombra do texto: vertical",
      "text-shadow-blur": "Desfoque da sombra do texto",
      "text-shadow-color": "Cor da sombra da fonte",
      "border-radius": "Raio da borda",
      border: "Borda",
      "border-width": "Largura da borda",
      "border-style": "Estilo da borda",
      "border-color": "Cor da borda",
      "box-shadow": "Sombra da box",
      "box-shadow-h": "Sombra da box: horizontal",
      "box-shadow-v": "Sombra da box: vertical",
      "box-shadow-blur": "Desfoque da sombra da box",
      "box-shadow-spread": "Extensão da sombra da box",
      "box-shadow-color": "Cor da sombra da box",
      "box-shadow-type": "Tipo de sombra da box",
      background: "Fundo",
      "background-color": "Cor de fundo",
      "background-image": "Imagem de fundo",
      "background-repeat": "Repetir fundo",
      "background-position": "Posição do fundo",
      "background-attachment": "Plugin de fundo",
      "background-size": "Tamanho do fundo",
      transition: "Transição",
      "transition-property": "Tipo de transição",
      "transition-duration": "Tempo de transição",
      "transition-timing-function": "Função do tempo da transição",
      perspective: "Perspectiva",
      transform: "Transformação",
      "flex-direction": "Direção Flex",
      "flex-wrap": "Flex wrap",
      "justify-content": "Ajustar conteúdo",
      "align-items": "Alinhar elementos",
      "align-content": "Alinhar conteúdo",
      order: "Ordem",
      "flex-basis": "Base Flex",
      "flex-grow": "Crescimento Flex",
      "flex-shrink": "Contração Flex",
      "align-self": "Alinhar-se",
    },
  },
  traitManager: {
    empty: "Selecione um elemento para usar o gerenciador de configurações",
    label: "Configurações do componente",
  },
};

let editor = null;

const TemplateEditor = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [exit, setExit] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsloading] = useState(false);
  const [btnSave, setBtnSave] = useState(false);
  const [btnSaveExit, setBtnSaveExit] = useState(false);
  const [confirmSaveTemplate, setConfirmSaveTemplate] = useState(false);
  const [confirmEditTemplate, setConfirmEditTemplate] = useState(false);
  const [confirmExitSaveTemplate, setConfirmExitSaveTemplate] = useState(false);
  const [confirmExitEditTemplate, setConfirmExitEditTemplate] = useState(false);
  const [templateName, setTemplateName] = useState("");
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorInvalid, setErrorInvalid] = useState(false);
  const [routeState, setRouteState] = useState(location.state);
  const [redirect, setRedirect] = useState(false);
  const [confirmClearCanvas, setConfirmClearCanvas] = useState(false);

  // Instância do editor (V2). O EditorProvider reage a esse state para
  // conectar os painéis React ao GrapesJS quando o init termina.
  const [editorInstance, setEditorInstance] = useState(null);

  // Sidebar recolhida (V2). Persistido em localStorage pelo SidebarTabs.
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    try {
      return localStorage.getItem("editor-v2-sidebar-collapsed") === "1";
    } catch {
      return false;
    }
  });

  // Ao alternar largura da sidebar, o canvas do GrapesJS mantém as dimensões
  // antigas até receber um resize/refresh. Chamamos os dois pra garantir.
  useEffect(() => {
    if (!editorInstance) return;
    const t = setTimeout(() => {
      try {
        editorInstance.refresh?.();
        window.dispatchEvent(new Event("resize"));
      } catch {}
    }, 250);
    return () => clearTimeout(t);
  }, [sidebarCollapsed, editorInstance]);

  // Dropdown de opções de preview (Tela cheia / Nova aba).
  const [previewMenu, setPreviewMenu] = useState({
    open: false,
    top: 0,
    left: 0,
  });

  // Ref sincronizado com routeState — necessário porque os comandos do
  // GrapesJS são registrados uma única vez e capturariam o valor antigo
  // via closure. Após o primeiro Salvar, atualizamos routeState para
  // editMode: true, e os comandos precisam enxergar o novo valor.
  const routeStateRef = useRef(routeState);

  // Discrimina a mensagem do alert de sucesso (Salvo vs Editado). Não dá
  // pra usar `routeState.template` porque após o primeiro create nós já
  // atualizamos routeState com o template criado.
  const [lastActionCreated, setLastActionCreated] = useState(false);

  // AuthLayout renderiza <Outlet /> duas vezes (layout web + mobile).
  // Só devemos renderizar o editor na instância visível para evitar
  // IDs duplicados no DOM e dupla inicialização do GrapesJS.
  const rootRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  useLayoutEffect(() => {
    const el = rootRef.current;
    if (el && el.offsetParent !== null) setIsVisible(true);
  }, []);

  // Mede a altura útil entre o topo do editor e o final do container do
  // <Outlet /> (Layout.js). Isso permite ao #spectre ocupar todo o espaço
  // disponível — inclusive o "espaço cinza" que sobrava por causa do
  // `minHeight: 100vh + marginBottom: 80` do container pai.
  const spacerRef = useRef(null);
  const [editorHeight, setEditorHeight] = useState(0);

  useLayoutEffect(() => {
    if (!isVisible) return;
    const measure = () => {
      if (!spacerRef.current) return;
      const spectreVisibleTop = document
        .getElementById("spectre")
        ?.getBoundingClientRect().top;
      const spacerTop = spacerRef.current.getBoundingClientRect().top;
      // A margem negativa do #spectre faz ele começar `offset` px acima
      // do spacer — precisamos considerar isso pra ele terminar exatamente
      // onde queremos.
      const offset =
        spectreVisibleTop != null && !Number.isNaN(spectreVisibleTop)
          ? spacerTop - spectreVisibleTop
          : 0;

      const footers = Array.from(document.querySelectorAll(".footer-section"));
      const footer = footers.find((f) => f.offsetParent !== null) || footers[0];
      const bottomLimit = footer
        ? footer.getBoundingClientRect().top
        : window.innerHeight;

      // Editor termina exatamente no topo do footer.
      setEditorHeight(Math.max(400, bottomLimit - spacerTop + offset));
    };
    // Espera um tick pra o DOM estabilizar (footer pode montar depois).
    measure();
    const t = setTimeout(measure, 100);
    window.addEventListener("resize", measure);
    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", measure);
    };
  }, [isVisible]);

  useEffect(() => {
    routeStateRef.current = routeState;
  }, [routeState]);

  function goBackUrl() {
    if (routeState?.urlToBack) {
      navigate(routeState.urlToBack, {
        state: {
          ...routeState,
        },
      });
    } else navigate(-1);
  }

  // Função para carregar o HTML no GrapesJS
  const loadHtmlIntoGrapesjs = (editor, html, css) => {
    editor.setComponents(html);
    // Templates antigos gravavam htmlJson === htmlString (ambos HTML).
    // Só aplicar como CSS se o conteúdo realmente parecer CSS.
    if (css && css !== html && !/<[a-z][\s\S]*>/i.test(css)) {
      editor.setStyle(css);
    }
  };

  const grapeJsInit = async () => {
    // Só carrega formulários quando estamos no contexto de um evento.
    // Sistema de modelos (isSystemTemplate) e outras entradas sem idEvent
    // não devem tentar buscar forms — a chamada falha e trava o init.
    let response = null;
    if (routeState.idEvent) {
      try {
        response = await getAllForms({
          eventId: routeState.idEvent,
          jwt: props.token,
          offset: 1,
          limit: 100,
          search: "",
        });
      } catch (e) {
        response = null;
      }
    }
    let formList = [];
    // Envolvemos os plugins em funções inline para passar as opções direto
    // (o pluginsOpts do grapesjs indexa por nome do plugin como string, e usar
    // chave computada com a função importada não bate com esse lookup).
    const webBlocks = [
      "column1",
      "column2",
      "column3",
      "text",
      "link",
      "image",
      "video",
      "map",
    ];
    const emailBlocks = [
      "sect100",
      "sect50",
      "sect30",
      "sect37",
      "button",
      "divider",
      "text",
      "text-sect",
      "image",
      "quote",
      "grid-items",
      "list-items",
    ];
    let pluginsConfig = {
      web: [
        (ed) =>
          blocksBasic(ed, {
            blocks: webBlocks,
            category: "Componentes",
          }),
        // O preset webpage adiciona os botões undo/redo/canvas-clear/import/
        // toggle-images ao painel `options`, análogo ao que o newsletter faz
        // no email.
        (ed) => webpage(ed, {}),
      ],
      email: [
        (ed) =>
          newsletter(ed, {
            blocks: emailBlocks,
            category: "Componentes de Email",
          }),
      ],
    };

    const forms = response?.data?.forms || [];
    // Mapa id → HTML atual — usado para sincronizar ao abrir em edição.
    const formsMap = {};
    forms.forEach((form) => {
      const htmlString = ReactDOMServer.renderToString(
        <FormMounted
          form={JSON.parse(form.json)}
          saveForm={() => null}
          components={() => null}
          setForm={() => null}
        />,
      );
      formsMap[form.id] = htmlString;
      formList.push({
        id: form.id,
        label: form.description,
        category: "Formulários",
        content: {
          tagName: "div",
          // Wrapper esperado pelo PublicTemplate (parseTemplateHtml) — o
          // htmlString salvo carrega esses data-attributes e é deles que
          // a página pública extrai formId + typeForm.
          attributes: {
            "data-form-container": "true",
            "data-form-id": form.id,
            "data-type-form":
              form.cadastro === true ? "cadastro" : "pesquisa",
          },
          content: htmlString,
          editable: false,
          droppable: false,
          removable: true,
          copyable: false,
          draggable: true,
        },
        attributes: { class: "fa fa-user-circle" },
      });
    });
    let editorConfig = {
      fromElement: 1,
      container: "#gjs",
      allowScripts: 1,
      forceClass: false,
      i18n: { locale: "pt", messages: { pt: ptLocale } },
      storageManager: {
        type: 0, // Storage type. Available: local | remote
      },
      // Upload de imagens: envia para a API de arquivos e usa a URL retornada
      // no lugar de base64 inline (evita HTML gigante / truncado no banco).
      assetManager: {
        uploadFile: async (e) => {
          const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
          if (!files || !files.length) return;
          const formData = new FormData();
          for (let i = 0; i < files.length; i++) {
            formData.append("files", files[i]);
          }
          const response = await getUrlFiles(
            formData,
            props.state.global_user_data.data.token,
          );
          if (Array.isArray(response)) {
            const urls = response.map((item) => item.url).filter(Boolean);
            if (urls.length) editor.AssetManager.add(urls);
          }
        },
      },

      canvas: {
        styles: [
          "https://cdn.jsdelivr.net/npm/bootstrap@5.1.0/dist/css/bootstrap.min.css",
          "https://unpkg.com/spectre.css/dist/spectre.min.css",
        ],
        scripts: [],
      },
      canvasCss: `
    .gjs-selected {
      outline: 2px solid #000 !important;
    }
    /* Classes do FormMounted (src/assets/scss/gs.scss) — pra formulários
       inseridos no template renderizarem igual ao /rsvp/formulario.
       Obs: no admin, .row-wrapper-form só empilha em telas <=900px. */
    /* Neutraliza .label do Spectre (fundo cinza como badge) no form. */
    .custom-input-container .label,
    .displayed-label > .label {
      background: transparent !important;
      padding: 0 !important;
      border-radius: 0 !important;
      font-size: inherit !important;
      color: inherit !important;
      line-height: inherit !important;
    }
    .custom-input-container { margin: 15px 0; }
    .displayed-config-container { display: flex; justify-content: space-between; }
    .displayed-config-container .displayed-label { display: flex; align-self: end; align-items: baseline; }
    .input-mg-rgt { margin-right: 10px; }
    .main-question-options { margin-bottom: 10px; font-size: 14px; font-weight: 700; }
    .form-label { display: inline-block; margin-bottom: 6px; margin-right: 2px; font-size: 14px; }
    .form-control { font-size: 14px; padding: 8px 12px; }
    button.displayed-label, .btn.displayed-label {
      align-self: auto !important;
      display: inline-flex !important;
      align-items: center;
      justify-content: center;
      padding: 10px 24px;
      font-size: 15px;
      line-height: 1.4;
      min-height: 42px;
      margin: 12px 0 24px;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      color: #fff;
    }
    /* Mock do Select (SelectDisplay SSR) */
    .ssr-select { position: relative; }
    .ssr-select > summary,
    .ssr-select-summary {
      list-style: none;
      width: 100%;
      min-height: 38px;
      padding: 6px 8px 6px 12px;
      border: 1px solid #cccccc;
      border-radius: 4px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: #808080;
      box-sizing: border-box;
      user-select: none;
    }
    .ssr-select > summary::-webkit-details-marker { display: none; }
    .ssr-select-arrow {
      display: flex;
      align-items: center;
      padding-left: 8px;
      border-left: 1px solid #cccccc;
      color: #cccccc;
      height: 20px;
    }
    .ssr-select-chevron { transition: transform 0.15s; }
    .ssr-select[open] .ssr-select-chevron { transform: rotate(180deg); }
    .ssr-select-menu {
      position: absolute;
      width: 100%;
      margin-top: 4px;
      background: #fff;
      border: 1px solid #cccccc;
      border-radius: 4px;
      box-shadow: 0 4px 11px rgba(0,0,0,0.1);
      max-height: 200px;
      overflow-y: auto;
      z-index: 10;
    }
    .ssr-select-option {
      padding: 8px 12px;
      font-size: 14px;
      color: #333;
      cursor: pointer;
      border-bottom: 1px solid #f0f0f0;
    }
    .ssr-select-option:last-child { border-bottom: none; }
    .ssr-select-option:hover { background: #f7f8fa; }
    @media (max-width: 900px) {
      .row-wrapper-form { display: flex; flex-direction: column; }
    }
    /* Fix Bootstrap 5 no canvas: form-check-input não deve ter float
       e nem margin negativa que assume parent .form-check. */
    .form-check-input {
      float: none !important;
      margin-left: 0 !important;
      margin-top: 0 !important;
      margin-right: 10px !important;
    }
    /* Wrapper flex de cada opção do Radio/CheckboxDisplay — alinhamento
       vertical no meio + espaçamento moderado entre opções. */
    [id^="therm-input-component"] > .custom-input-container > div[style*="display: flex"] {
      align-items: center;
      margin: 0 0 8px 0;
    }
    [class*="check-label-"] {
      padding: 0 !important;
      margin: 0 !important;
      line-height: 1.4 !important;
      align-self: center;
    }
    /* Título da pergunta (span com class main-question-options-*) — margem
       inferior pra separar visualmente da primeira opção. */
    [class*="main-question-options-"] {
      display: block;
      margin-bottom: 8px;
    }
    /* Impede que eventos de mouse cheguem nos filhos do wrapper de formulário.
       Isso faz o GrapesJS detectar hover/click apenas no wrapper inteiro,
       não em inputs, labels ou outros elementos internos. */
    [data-form-id] * {
      pointer-events: none !important;
    }
    `,
      blockManager: {
        appendTo: "#blocks",
      },
      styleManager: {
        appendTo: "#style-manager-container",
      },
      traitManager: {
        appendTo: "#traits-container",
      },
      layerManager: {
        appendTo: "#layers-manager-container",
        custom: true,
      },
      plugins: pluginsConfig[routeState.type_template],
      blockManager: {
        appendTo: "#blocks",
        blocks: [
          {
            id: "link-block",
            label: "Bloco de Link",
            type: "web",
            category: "Componentes",
            content: '<a href="#" class="link-block">Link Block</a>',
            attributes: { class: "fa fa-link" },
          },
          {
            id: "quote",
            label: "Citação",
            type: "web",
            category: "Componentes",
            content: "<blockquote>Insert quote here</blockquote>",
            attributes: { class: "fa fa-quote-right" },
          },

          {
            id: "text-basic",
            label: "Seção de Texto",
            type: "web",
            category: "Componentes",
            content:
              '<section class="bdg-sect"><h1 class="heading">Insert title here</h1><p class="paragraph">Insert text here</p></section>',
            attributes: { class: "fa fa-font" },
          },
          ...formList,
        ],
      },
    };
    //segmentar por categoria
    editorConfig.blockManager.blocks = editorConfig.blockManager.blocks.filter(
      (e) => {
        if (routeState.type_template != "web")
          return e.category != "Formulários" && e.type != "web";
        else return e;
      },
    );
    editor = grapesjs.init(editorConfig);
    setEditorInstance(editor);

    // Os presets webpage/newsletter hardcodam nomes de setores/propriedades
    // em inglês (não usam o i18n do GrapesJS). Renomeamos pós-init.
    // Para reverter: remover este bloco inteiro até `editor.on("component:add", renameComponent);`.
    const sectorMap = {
      General: "Geral",
      Dimension: "Dimensão",
      Typography: "Tipografia",
      Decorations: "Decorações",
      Extra: "Extra",
      Flex: "Flex",
    };
    const propertyMap = {
      Width: "Largura",
      Height: "Altura",
      "Min-width": "Largura Mín.",
      "Min width": "Largura Mín.",
      "Min Width": "Largura Mín.",
      "Min-height": "Altura Mín.",
      "Min height": "Altura Mín.",
      "Min Height": "Altura Mín.",
      "Max-width": "Largura Máx.",
      "Max width": "Largura Máx.",
      "Max Width": "Largura Máx.",
      "Max-height": "Altura Máx.",
      "Max height": "Altura Máx.",
      "Max Height": "Altura Máx.",
      Margin: "Margem",
      Padding: "Padding",
      Font: "Fonte",
      "Font family": "Tipo de letra",
      "Font size": "Tamanho da fonte",
      "Font weight": "Espessura da fonte",
      "Letter spacing": "Espaço entre letras",
      Color: "Cor",
      "Line height": "Altura da linha",
      "Text align": "Alinhamento",
      "Vertical align": "Alinhamento vertical",
      "Text shadow": "Sombra do texto",
      Background: "Fundo",
      "Background color": "Cor de fundo",
      "Background image": "Imagem de fundo",
      Border: "Borda",
      "Border radius": "Raio da borda",
      "Border collapse": "Fusão de bordas",
      "Box shadow": "Sombra da caixa",
      Display: "Exibição",
      Position: "Posição",
      Float: "Float",
      Top: "Topo",
      Right: "Direita",
      Bottom: "Inferior",
      Left: "Esquerda",
      Opacity: "Opacidade",
      Alignment: "Alinhamento",
      Align: "Alinhamento",
    };
    const componentMap = {
      Section: "Seção",
      Column: "Coluna",
      Row: "Linha",
      Cell: "Célula",
      Button: "Botão",
      Divider: "Divisor",
      Spacer: "Espaçador",
      Text: "Texto",
      "Text section": "Seção de texto",
      Image: "Imagem",
      Link: "Link",
      Wrapper: "Corpo",
      Body: "Corpo",
      Grid: "Grade",
      List: "Lista",
      Quote: "Citação",
    };
    const translateStyleManager = () => {
      const sm = editor.StyleManager;
      if (sm && sm.getSectors) {
        sm.getSectors().each((sector) => {
          const name = sector.get("name");
          if (sectorMap[name]) sector.set("name", sectorMap[name]);
          const props = sector.get("properties");
          if (props && props.each) {
            props.each((prop) => {
              const pname = prop.get("name");
              if (propertyMap[pname]) prop.set("name", propertyMap[pname]);
            });
          }
        });
      }
      // Fallback: as views do StyleManager/LayerManager renderizam o título
      // uma vez e não observam `change:name`. Iteramos qualquer nó de texto
      // dentro dos containers e substituímos se casar com um dos mapas.
      requestAnimationFrame(() => {
        const applyMapToTextNodes = (root, map) => {
          if (!root) return;
          const walker = document.createTreeWalker(
            root,
            NodeFilter.SHOW_TEXT,
            null,
          );
          const nodes = [];
          while (walker.nextNode()) nodes.push(walker.currentNode);
          nodes.forEach((n) => {
            const txt = (n.textContent || "").trim();
            if (txt && map[txt])
              n.textContent = n.textContent.replace(txt, map[txt]);
          });
        };
        const smC = document.getElementById("style-manager-container");
        applyMapToTextNodes(smC, sectorMap);
        applyMapToTextNodes(smC, propertyMap);
        const layC = document.getElementById("layers-manager-container");
        applyMapToTextNodes(layC, componentMap);
      });
    };
    const renameComponent = (comp) => {
      if (!comp) return;
      const cname = comp.get("name");
      if (cname && componentMap[cname]) comp.set("name", componentMap[cname]);
      const children = comp.components && comp.components();
      if (children && children.each) children.each(renameComponent);
    };
    // Roda em múltiplos eventos porque os presets podem adicionar setores
    // dinamicamente ao selecionar componentes específicos.
    editor.on("load", () => {
      translateStyleManager();
      renameComponent(editor.getWrapper());
    });
    editor.on("component:selected", translateStyleManager);
    editor.on("style:sector:add", translateStyleManager);
    editor.on("component:add", renameComponent);

    // Trava componentes dentro de wrappers data-form-id (drag-and-drop e editMode).
    const lockDescendants = (comps) => {
      comps.each((c) => {
        c.set({ editable: false, selectable: false, highlightable: false, draggable: false });
        lockDescendants(c.components());
      });
    };
    // Regra: apenas 1 formulário por template. Quando o canvas já tem um
    // form, os blocos da categoria "Formulários" ficam desabilitados
    // visualmente na sidebar.
    // Usa DOM query direto (mais robusto que block.view.el que pode não
    // estar populado no momento da chamada).
    function updateFormBlocksAvailability() {
      const wrapper = editor.getWrapper();
      const existingForm = wrapper?.find?.("[data-form-id]") || [];
      const hasForm = existingForm.length > 0;

      // Descobre os IDs dos blocos de "Formulários" no BlockManager.
      const formBlockIds = [];
      editor.BlockManager.getAll().each((block) => {
        if (block.get("category") === "Formulários") {
          formBlockIds.push(block.id || block.get("id"));
        }
      });

      // Aplica/remove a classe nos elementos do DOM (o BlockManager
      // renderiza dentro de #blocks; cada bloco tem id="gjs-block-<id>").
      const blocksContainer = document.getElementById("blocks");
      if (!blocksContainer) return;

      formBlockIds.forEach((id) => {
        // O GrapesJS renderiza cada block como .gjs-block, tentamos localizar
        // por várias heurísticas.
        const nodes = blocksContainer.querySelectorAll(".gjs-block");
        nodes.forEach((node) => {
          // Compara pelo texto (label do bloco) ou pelo id do bloco no dataset.
          const dataId = node.getAttribute("data-block-id");
          if (dataId && dataId !== id) return;
          node.classList.toggle("gjs-block-disabled", hasForm);
          node.setAttribute(
            "title",
            hasForm
              ? "Este template já tem um formulário. Remova o atual para adicionar outro."
              : node.getAttribute("data-original-title") || "",
          );
        });
      });

      // Fallback bruto: todo bloco dentro de uma categoria "Formulários" fica
      // desabilitado. Percorre as categorias do DOM procurando pelo título.
      const categories = blocksContainer.querySelectorAll(".gjs-block-category");
      categories.forEach((cat) => {
        const title = cat.querySelector(".gjs-title");
        const titleText = (title?.textContent || "").trim();
        if (!titleText.includes("Formulários")) return;
        cat.querySelectorAll(".gjs-block").forEach((node) => {
          node.classList.toggle("gjs-block-disabled", hasForm);
          if (hasForm) {
            node.setAttribute(
              "title",
              "Este template já tem um formulário. Remova o atual para adicionar outro.",
            );
          } else {
            node.removeAttribute("title");
          }
        });
      });
    }

    editor.on("component:add", (comp) => {
      const attrs = comp.getAttributes?.() || {};
      if (attrs["data-form-id"]) {
        comp.set({ editable: false, droppable: false, removable: true, copyable: false });
        // Trava filhos já presentes (setComponents popula antes do evento).
        lockDescendants(comp.components());
        // Trava filhos adicionados depois do evento (drag-and-drop).
        setTimeout(() => lockDescendants(comp.components()), 0);
        updateFormBlocksAvailability();
        return;
      }
      // Fallback: trava se qualquer ancestral for um wrapper de formulário.
      let ancestor = comp.parent?.();
      while (ancestor) {
        if (ancestor.getAttributes?.()?.["data-form-id"]) {
          comp.set({ editable: false, selectable: false, highlightable: false, draggable: false });
          return;
        }
        ancestor = ancestor.parent?.();
      }
    });

    editor.on("component:remove", () => {
      // setTimeout(0) — no momento do evento, o wrapper.find() ainda enxerga
      // o componente sendo removido. Deixa o próximo tick pra reavaliar
      // com o DOM/tree já atualizado.
      setTimeout(updateFormBlocksAvailability, 0);
    });
    // Estado inicial (também cobre edit mode com form já salvo). Dois
    // timeouts pra dar tempo do BlockManager renderizar os blocos no DOM.
    editor.on("load", () => {
      setTimeout(updateFormBlocksAvailability, 0);
      setTimeout(updateFormBlocksAvailability, 500);
    });

    // Cancela o drag se o bloco arrastado é de "Formulários" e o canvas
    // já tem um form.
    editor.on("block:drag:start", (block) => {
      if (block?.get?.("category") !== "Formulários") return;
      const wrapper = editor.getWrapper();
      const existingForm = wrapper?.find?.("[data-form-id]") || [];
      if (existingForm.length > 0) {
        editor.stopCommand?.("tlb-drag");
        const dragger = editor.Commands.get?.("tlb-drag");
        if (dragger?.stop) dragger.stop(editor);
      }
    });

    //editor.Panels.removeButton('options', 'export-template');
    editor.Panels.removeButton("options", "fullscreen");
    editor.Panels.removeButton("options", "preview");
    //editor.Panels.removeButton('options', 'gjs-open-import-webpage');

    // Botões custom no painel legado — pulamos quando a topbar moderna
    // está ativa (os mesmos comandos são chamados pelo EditorTopbar).
    if (!USE_MODERN_TOPBAR) {
      editor.Panels.addButton("options", {
        id: "save-template",
        className: "custom-save-button",
        label: `<i class="fa fa-save"></i> Salvar`,
        command: "save-template",
        attributes: { title: "Salvar" },
      });

      editor.Panels.addButton("options", {
        id: "save-template-exit",
        className: "custom-save-button",
        label: `<i class="fa fa-save"></i> Salvar e Sair`,
        command: "save-template-exit",
        attributes: { title: "Salvar e Sair" },
      });

      editor.Panels.addButton("options", {
        id: "preview-menu",
        className: "custom-save-button",
        label: `<i class="fa fa-eye"></i> Visualizar`,
        command: "open-preview-menu",
        attributes: { title: "Pré-visualizar template" },
      });

      editor.Panels.addButton("options", {
        id: "exit",
        className: "custom-save-button",
        label: `<i class="fa fa-close"></i> Sair`,
        command: "exit",
        attributes: { title: "Sair" },
      });
    }

    // Abre o dropdown de opções de preview posicionado abaixo do botão.
    editor.Commands.add("open-preview-menu", {
      run: () => {
        const btn = document.querySelector(
          '.gjs-pn-btn[title="Pré-visualizar template"]',
        );
        if (!btn) return;
        const rect = btn.getBoundingClientRect();
        setPreviewMenu({
          open: true,
          top: rect.bottom + 4,
          left: rect.left,
        });
      },
    });

    // Fullscreen + preview (esconde painéis e maximiza).
    // Cleanup atende três fontes de "saída": eventos do GrapesJS
    // (stop:preview/stop:fullscreen) e o fullscreenchange do próprio browser
    // (ESC pode sair do fullscreen sem emitir o evento do GrapesJS).
    editor.Commands.add("fullscreen-preview", {
      run: (ed) => {
        ed.runCommand("fullscreen");
        ed.runCommand("preview");
        const cleanup = () => {
          ed.off("stop:preview", cleanup);
          ed.off("stop:fullscreen", cleanup);
          document.removeEventListener("fullscreenchange", onFsChange);
          if (ed.Commands && ed.Commands.isActive) {
            if (ed.Commands.isActive("preview")) ed.stopCommand("preview");
            if (ed.Commands.isActive("fullscreen"))
              ed.stopCommand("fullscreen");
          }
        };
        const onFsChange = () => {
          if (!document.fullscreenElement) cleanup();
        };
        ed.once("stop:preview", cleanup);
        ed.once("stop:fullscreen", cleanup);
        document.addEventListener("fullscreenchange", onFsChange);
      },
    });

    // Abre o template renderizado em uma nova aba — usa o mesmo doc do
    // preview modal (buildPreviewDoc) pra garantir Bootstrap/Spectre/FORM_CSS
    // e o script do mock do Select.
    editor.Commands.add("preview-tab", {
      run: (ed) => {
        const win = window.open("", "_blank");
        if (!win) return;
        win.document.write(buildPreviewDoc(ed.getHtml(), ed.getCss()));
        win.document.close();
      },
    });

    editor.Commands.add("exit", {
      run: async () => {
        goBackUrl();
      },
    });

    editor.Commands.add("save-template", {
      run: async () => {
        setRedirect(false);
        if (routeStateRef.current.editMode) {
          setConfirmEditTemplate(true);
        } else {
          setConfirmSaveTemplate(true);
        }
      },
    });

    editor.Commands.add("save-template-exit", {
      run: async () => {
        if (routeStateRef.current.editMode) {
          setConfirmExitEditTemplate(true);
          setConfirmEditTemplate(true);
        } else {
          setConfirmExitSaveTemplate(true);
          setConfirmSaveTemplate(true);
        }
      },
    });

    // Sobrescreve o `canvas-clear` dos presets webpage/newsletter que
    // usam `confirm()` nativo do browser. Abre um SweetAlert no padrão da
    // aplicação (o `core:canvas-clear` é o comando interno que faz a
    // limpeza; o preset só o envolvia num confirm).
    editor.Commands.add("canvas-clear", {
      run: () => setConfirmClearCanvas(true),
    });

    //remove uneeded body wrapper from mjml
    editor.getWrapper().toHTML = function (opts) {
      return this.getInnerHTML(opts);
    };

    //open style manager once block is dropped or clicked
    editor.on("block:drag:stop component:selected", function (model) {
      let tagName = model?.attributes?.tagName;
      if (tagName && tagName != "mj-section") {
        window.openPanel("styles");
      }
    });

    //prevent janky rendering

    // Adicione este código após a inicialização do editor
    editor.on("load", () => {
      /* mudar cor dos ícones */
      const style = document.createElement("style");
      style.textContent = `
      .gjs-block__media i {
        color: #ff0000  !important;
      }
    `;
      document.head.appendChild(style);

      /* resto do bloco config */
      const categories = editor.BlockManager.getCategories();

      // Localiza o container real dos blocos da categoria. Dependendo da
      // versão do grapesjs, view.el pode ser o .gjs-title ou o próprio
      // .gjs-block-category — então subimos até achar o .gjs-block-category
      // e pegamos o .gjs-blocks-c dentro dele.
      const findCategoryEls = (cat) => {
        const rootEl = cat.view?.el;
        if (!rootEl) return {};
        const catEl = rootEl.closest
          ? rootEl.closest(".gjs-block-category") || rootEl
          : rootEl;
        const titleEl =
          catEl.querySelector(".gjs-title") ||
          (rootEl.matches?.(".gjs-title") ? rootEl : null);
        const blocksC = catEl.querySelector(".gjs-blocks-c");
        return { catEl, titleEl, blocksC };
      };

      const closeCategoryDom = (cat) => {
        const { titleEl, blocksC } = findCategoryEls(cat);
        if (blocksC) blocksC.style.display = "none";
        if (titleEl) {
          const chevron = titleEl.querySelector(
            ".fa-chevron-down, .fa-chevron-up",
          );
          if (chevron) {
            chevron.className = "fa fa-chevron-down";
            chevron.style.transform = "rotate(0deg)";
          }
        }
        cat.set("open", false);
      };

      const renderCategory = (category) => {
        const { titleEl } = findCategoryEls(category);
        const iconClass =
          categoryIcons[category.get("label")] || "fa fa-folder";
        if (titleEl) {
          titleEl.innerHTML = `
          <i class="${iconClass}" style="margin-right: 5px; font-size:22px;color:#9933dc;"></i>
          ${category.get("label")}
          <i class="fa fa-chevron-down" style="float: right; transition: transform 0.3s;"></i>
        `;
        }

        // Estado inicial: fechado no model e no DOM.
        closeCategoryDom(category);

        if (!titleEl) return;
        // O GrapesJS registra um `click .gjs-title` delegado no pai
        // `.gjs-block-category` (Backbone) que chama `model.set('open', !open)`.
        // Se deixarmos o evento borbulhar, ele desfaz nosso toggle. Usamos
        // stopPropagation para sermos a única fonte de verdade do open/close.
        titleEl.onclick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          const { blocksC } = findCategoryEls(category);
          const isOpen = blocksC && blocksC.style.display !== "none";

          // Fecha as outras categorias.
          categories.each((cat) => {
            if (cat !== category) closeCategoryDom(cat);
          });

          // Alterna a categoria clicada.
          if (blocksC) blocksC.style.display = isOpen ? "none" : "";
          category.set("open", !isOpen);

          const chevron = titleEl.querySelector(
            ".fa-chevron-down, .fa-chevron-up",
          );
          if (chevron) {
            chevron.className = isOpen
              ? "fa fa-chevron-down"
              : "fa fa-chevron-up";
          }
        };
      };

      // Renderizar todas as categorias existentes
      categories.each(renderCategory);

      // Aplicar em categorias adicionadas depois (por plugins/blocos assíncronos)
      editor.on("block-category:add", (category) => {
        renderCategory(category);
      });

      // Traduzir tooltips (title) dos botões padrão do GrapesJS/newsletter
      // preset para PT-BR. O `ButtonsView` descarta a referência da view
      // após render (não expõe `model.view`) e o `ButtonView` não seta ID
      // no DOM (define `this.id` só no initialize, tarde demais para o
      // Backbone `_ensureElement`). Localizamos pelo container do painel
      // (`.gjs-pn-<panelId>`) e correlacionamos os botões por posição com
      // os models da collection. Um MutationObserver reverte qualquer
      // sobrescrita futura do `title` (ex: `sw-visibility` re-renderiza
      // ao alternar `active` e o `updateAttributes` reseta para "View
      // components" via `em.t`).
      const tooltipsPT = {
        "sw-visibility": "Exibir bordas dos componentes",
        "export-template": "Ver código",
        "gjs-open-import-template": "Importar template",
        "gjs-open-import-webpage": "Importar página",
        "gjs-toggle-images": "Alternar imagens",
        undo: "Desfazer",
        redo: "Refazer",
        "canvas-clear": "Limpar canvas",
      };
      const panelIds = ["options", "commands", "views"];
      panelIds.forEach((panelId) => {
        const panel = editor.Panels.getPanel(panelId);
        if (!panel) return;
        const container = document.querySelector(`.gjs-pn-${panelId}`);
        if (!container) return;
        const btnEls = container.querySelectorAll(".gjs-pn-btn");
        panel.get("buttons").forEach((btnModel, idx) => {
          const title = tooltipsPT[btnModel.get("id")];
          if (!title) return;
          const el = btnEls[idx];
          if (!el) return;
          el.setAttribute("title", title);
          const observer = new MutationObserver(() => {
            if (el.getAttribute("title") !== title) {
              el.setAttribute("title", title);
            }
          });
          observer.observe(el, {
            attributes: true,
            attributeFilter: ["title"],
          });
        });
      });

      // Traduz labels dos blocos registrados pelos presets `blocksBasic`
      // (web) e `newsletter` (email). O BlockView renderiza
      // `em.t('blockManager.labels.<id>') || model.get('label')` e escuta
      // `change` no model — então setar `label` dispara re-render.
      const blockLabelsPT = {
        // blocksBasic (web)
        column1: "1 Coluna",
        column2: "2 Colunas",
        column3: "3 Colunas",
        "column3-7": "2 Colunas 3/7",
        text: "Texto",
        link: "Link",
        image: "Imagem",
        video: "Vídeo",
        map: "Mapa",
        // newsletter (email)
        sect100: "1 Seção",
        sect50: "Seção 1/2",
        sect30: "Seção 1/3",
        sect37: "Seção 3/7",
        button: "Botão",
        divider: "Divisor",
        "text-sect": "Seção de Texto",
        quote: "Citação",
        "grid-items": "Itens em Grade",
        "list-items": "Itens em Lista",
      };
      editor.BlockManager.getAll().each((block) => {
        const ptLabel = blockLabelsPT[block.id];
        if (ptLabel) block.set("label", ptLabel);
      });

      document.getElementById("gjs").style.display = "block";

      setLoading(false);
    });

    /* editor.Panels.addPanel({
      id: "options",
      buttons: [
        {
          id: "undo",
          className: "fa fa-undo",
          command: "undo",
          attributes: { title: "Undo" },
        },
        {
          id: "redo",
          className: "fa fa-redo",
          command: "redo",
          attributes: { title: "Redo" },
        },
        {
          id: "preview",
          className: "fa fa-eye",
          command: "preview",
          attributes: { title: "Preview" },
        },
        {
          id: "fullscreen",
          className: "fa fa-arrows-alt",
          command: "fullscreen",
          attributes: { title: "Fullscreen" },
        },
        {
          id: "export-template",
          className: "fa fa-code",
          command: "export-template",
          attributes: { title: "View Code" },
        },
      ],
    }); */

    editor.Panels.getButton("options", "sw-visibility").set("active", false);
    editor.Panels.getButton("views", "open-blocks").set("active", true);
    editor.Panels.removeButton("options", "fullscreen");
    editor.Panels.removeButton("options", "preview");

    editor.getWrapper().toHTML = function (opts) {
      return this.getInnerHTML(opts);
    };

    editor.on("block:drag:stop component:selected", function (model) {
      let tagName = model?.attributes?.tagName;
      if (tagName && tagName != "mj-section") {
        window.openPanel("styles");
      }
    });
    if (location?.state?.editMode) {
      loadHtmlIntoGrapesjs(
        editor,
        location?.state?.template?.htmlString,
        location?.state?.template?.htmlJson,
      );
      // Trava os filhos de um wrapper de formulário.
      const lockAllDescendants = (comps) => {
        comps.each((c) => {
          c.set({ editable: false, selectable: false, highlightable: false, draggable: false });
          lockAllDescendants(c.components());
        });
      };

      // Percorre todos os componentes, trava os wrappers data-form-id e seus
      // filhos, e sincroniza o HTML com a versão atual do form (se disponível).
      // O lock acontece independente do sync — cobre templates sem idEvent.
      // `removable: true` mantém a lixeira do form funcional em edit mode
      // (mesmo comportamento de quando o form é arrastado novo).
      const applyFormLocks = (components) => {
        components.each((comp) => {
          const id = comp.getAttributes?.()?.["data-form-id"];
          if (id) {
            comp.set({
              editable: false,
              droppable: false,
              removable: true,
              copyable: false,
            });
            if (formsMap[id]) comp.components(formsMap[id]);
            lockAllDescendants(comp.components());
            return;
          }
          applyFormLocks(comp.components());
        });
      };

      applyFormLocks(editor.getWrapper().components());

      // Segunda passagem após um tick — cobre casos em que setComponents
      // ainda não terminou de popular a árvore de componentes de forma síncrona.
      setTimeout(() => applyFormLocks(editor.getWrapper().components()), 0);
    }
    // MOCK_SYSTEM_TEMPLATES — carrega o template pré-selecionado do picker.
    // Para reverter: remover este bloco (mantém-se editMode como antes).
    else if (location?.state?.seedTemplate)
      loadHtmlIntoGrapesjs(
        editor,
        location.state.seedTemplate.htmlString,
        location.state.seedTemplate.htmlJson,
      );

    editor.Panels.removePanel("views");
    window.editor = editor;
  };

  useEffect(() => {
    if (!isVisible) return;
    grapeJsInit();
  }, [isVisible]);

  // trava o item ativo do sidebar conforme o tipo de template
  useEffect(() => {
    if (!isVisible) return;
    const sidebarMap = { email: ["27", "EMAIL"], web: ["28", "PAGINA_WEB"] };
    const entry = sidebarMap[routeState?.type_template];
    if (entry) props.openEvent(entry[0], entry[1]);
  }, [isVisible]);
  return (
    <div ref={rootRef}>
      {isVisible && (
        <React.Fragment>
          {previewMenu.open && (
            <>
              <div
                onClick={() => setPreviewMenu({ open: false, top: 0, left: 0 })}
                style={{
                  position: "fixed",
                  inset: 0,
                  zIndex: 1049,
                  background: "transparent",
                }}
              />
              <div
                style={{
                  position: "fixed",
                  top: previewMenu.top,
                  left: previewMenu.left,
                  zIndex: 1050,
                  background: "#fff",
                  border: "1px solid #ddd",
                  borderRadius: 4,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  minWidth: 180,
                  padding: 4,
                }}
              >
                <button
                  type="button"
                  className="btn btn-link text-start w-100"
                  style={{ color: "#333", textDecoration: "none" }}
                  onClick={() => {
                    setPreviewMenu({ open: false, top: 0, left: 0 });
                    editor.runCommand("fullscreen-preview");
                  }}
                >
                  <i className="fa fa-expand me-2" /> Tela cheia
                </button>
                <button
                  type="button"
                  className="btn btn-link text-start w-100"
                  style={{ color: "#333", textDecoration: "none" }}
                  onClick={() => {
                    setPreviewMenu({ open: false, top: 0, left: 0 });
                    editor.runCommand("preview-tab");
                  }}
                >
                  <i className="fa fa-external-link me-2" /> Nova aba
                </button>
              </div>
            </>
          )}
          {loading && (
            <div
              className="loading-overlay "
              style={{ flexDirection: "column" }}
            >
              <div className="loading-spinner"></div>
            </div>
          )}

          {/* <link rel="stylesheet" href="./modal.css" />
      <link rel="stylesheet" href="./custom.css" /> */}
          <Helmet>
            <title>Editor | Inteegra Plus</title>
          </Helmet>
          {confirmClearCanvas && (
            <SweetAlert
              warning
              showCancel
              confirmBtnText="Sim"
              cancelBtnText="Não"
              confirmBtnBsStyle="success"
              cancelBtnBsStyle="danger"
              title="Limpar canvas"
              onConfirm={() => {
                editor.runCommand("core:canvas-clear");
                setConfirmClearCanvas(false);
              }}
              onCancel={() => setConfirmClearCanvas(false)}
            >
              Todo o conteúdo do editor será removido. Você não poderá reverter
              essa ação.
            </SweetAlert>
          )}
          <SweetAlert
            show={confirmSaveTemplate}
            warning
            showCancel
            confirmBtnText={
              isLoading ? (
                <>
                  Salvar <Spinner size="sm" className="ms-1" />
                </>
              ) : (
                "Salvar"
              )
            }
            cancelBtnText="Cancelar"
            confirmBtnBsStyle={isLoading ? "secondary" : "success"}
            cancelBtnBsStyle="danger"
            cancelBtnCssClass={isLoading ? "disabled" : ""}
            disabled={isLoading}
            title={`Salvar Template`}
            onConfirm={async () => {
              if (isLoading) return;
              if (!templateName.trim()) {
                setErrorInvalid(true);
                return;
              }
              setIsloading(true);

              const [createRes] = await Promise.all([
                createTemplate({
                  jwt: props.state.global_user_data.data.token,
                  payload: {
                    name: templateName,
                    type: routeState.type_template,
                    htmlString: editor.getHtml(),
                    htmlJson: editor.getCss(),
                    // Fix: usa idEvent/eventId do state quando disponível.
                    // Antes o eventId só era gravado quando `private=true`,
                    // deixando templates órfãos (event_id null) em outros
                    // fluxos de criação — inutilizava o PublicTemplate.
                    eventId:
                      routeState?.eventId ||
                      routeState?.idEvent ||
                      (routeState?.private ? routeState.id : null),
                    // MOCK_SYSTEM_TEMPLATES — flag para o backend gravar como modelo
                    isSystemTemplate: !!routeState.isSystemTemplate,
                  },
                }),
                new Promise((resolve) => setTimeout(resolve, 1000)),
              ]);
              // Guarda o template criado no routeState para que os próximos
              // "Salvar" / "Salvar e Sair" caiam no fluxo de update em vez de
              // criar duplicatas.
              //
              // Formato observado da API: { data: { message: "CREATED_TEMPLATE",
              // data: "<uuid>" } } — o id vem como string em response.data.data.
              // Também cobrimos formatos alternativos por segurança.
              const body = createRes?.data;
              let createdId;
              let created;
              if (typeof body?.data === "string") {
                createdId = body.data;
                created = { id: createdId };
              } else {
                created = body?.data || body?.template || body?.result || body;
                createdId = created?.id || created?._id || body?.id;
              }

              if (createdId) {
                setRouteState((prev) => ({
                  ...prev,
                  editMode: true,
                  template: {
                    ...(created || {}),
                    id: createdId,
                    name: templateName,
                  },
                }));
              } else {
                console.warn(
                  "[HtmlEditorV2] createTemplate: id não encontrado na resposta — o próximo Salvar/Salvar e Sair pode duplicar.",
                  createRes,
                );
              }
              setLastActionCreated(true);
              setConfirmEditTemplate(false);
              setSuccessMessage(true);
              setConfirmSaveTemplate(false);
              setIsloading(false);
            }}
            onCancel={() => {
              if (isLoading) return;
              setErrorInvalid(false);
              setConfirmSaveTemplate(false);
            }}
          >
            Para continuar, defina um nome para esse template...
            <br />
            <br />
            <br />
            <FormGroup className="position-relative ">
              <Input
                className={
                  errorInvalid ? "form-control is-invalid" : "form-control"
                }
                invalid={errorInvalid}
                placeholder=""
                type="text"
                required
                onChange={(e) => {
                  setTemplateName(e.target.value);
                  if (errorInvalid && e.target.value.trim()) {
                    setErrorInvalid(false);
                  }
                }}
                value={templateName}
              />
              <FormFeedback style={{ textAlign: "left", paddingTop: 13 }}>
                Preencha o campo nome do template.
              </FormFeedback>
            </FormGroup>
          </SweetAlert>

          {confirmEditTemplate && (
            <SweetAlert
              warning
              showCancel
              confirmBtnText={
                isLoading ? (
                  <>
                    Aplicar <Spinner size="sm" className="ms-1" />
                  </>
                ) : (
                  "Aplicar"
                )
              }
              cancelBtnText="Cancelar"
              confirmBtnBsStyle={isLoading ? "secondary" : "success"}
              cancelBtnBsStyle="danger"
              cancelBtnCssClass={isLoading ? "disabled" : ""}
              disabled={isLoading}
              title={`Editar Template`}
              onConfirm={async () => {
                if (isLoading) return;
                setIsloading(true);

                await Promise.all([
                  updateTemplate({
                    jwt: props.state.global_user_data.data.token,
                    payload: {
                      id: routeState.template.id,
                      name: routeState.template.name,
                      type: routeState.type_template,
                      htmlString: editor.getHtml(),
                      htmlJson: editor.getCss(),
                      // Fix: preserva o eventId original do template ao editar.
                      // Antes era hardcoded null — toda edição zerava o vínculo
                      // do template com o evento, quebrando o PublicTemplate.
                      eventId:
                        routeState?.template?.eventId ||
                        routeState?.template?.event_id ||
                        routeState?.eventId ||
                        routeState?.idEvent ||
                        null,
                      // MOCK_SYSTEM_TEMPLATES — mantém flag do modelo ao atualizar
                      isSystemTemplate: !!routeState.isSystemTemplate,
                    },
                  }),
                  new Promise((resolve) => setTimeout(resolve, 1000)),
                ]);
                setLastActionCreated(false);
                setSuccessMessage(true);
                setConfirmEditTemplate(false);
                setIsloading(false);
              }}
              onCancel={() => {
                if (isLoading) return;
                setConfirmEditTemplate(false);
              }}
            >
              Aplicar alterações no template?
              <br />
              <br />
              <br />
            </SweetAlert>
          )}

          <SweetAlert
            show={successMessage}
            success
            confirmBtnText="OK"
            confirmBtnBsStyle="info"
            confirmBtnStyle={{
              backgroundColor: "#556ee6",
              borderColor: "#556ee6",
              boxShadow: "none",
            }}
            title={`Sucesso`}
            onConfirm={() => {
              setSuccessMessage(false);
              if (confirmExitEditTemplate) {
                goBackUrl();
              }
              if (confirmExitSaveTemplate) {
                goBackUrl();
              }
            }}
            onCancel={() => {
              setSuccessMessage(false);
            }}
          >
            {lastActionCreated
              ? "Template Salvo com sucesso!"
              : "Template Editado com sucesso!"}
          </SweetAlert>

          <EditorProvider editor={editorInstance}>
            {/* Spacer invisível: mede o topo onde o editor começa (logo abaixo
                do Header do admin). Usamos essa medida para dar ao #spectre
                altura = viewport - topo, sem travar o scroll da página. */}
            <div ref={spacerRef} style={{ height: 0, width: "100%" }} />
            <div
              id="spectre"
              className={`spectre ${
                USE_MODERN_TOPBAR ? "v2-topbar-active" : ""
              }`}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "stretch",
                flexWrap: "nowrap",
                // Altura medida dinamicamente = do topo do editor até o
                // final do container pai (aproveita todo o espaço cinza).
                height: editorHeight
                  ? `${editorHeight}px`
                  : "calc(100vh - 60px)",
                margin: "-20px",
                width: "calc(100% + 40px)",
              }}
            >
              <div
                id="style-manager"
                className="column"
                style={{
                  flexBasis: sidebarCollapsed ? 48 : 390,
                  minWidth: sidebarCollapsed ? 48 : 360,
                  maxWidth: sidebarCollapsed ? 48 : "none",
                  overflow: "hidden",
                  borderRight: "none",
                  transition: "flex-basis 0.2s ease, min-width 0.2s ease",
                }}
              >
                <SidebarTabs onCollapseChange={setSidebarCollapsed} />
              </div>
              <div
                className="column editor-clm"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: 0,
                }}
              >
                {USE_MODERN_TOPBAR && (
                  <EditorTopbar templateType={routeState?.type_template} />
                )}
                <div id="gjs" style={{ flex: 1, minHeight: 0 }}></div>
              </div>
            </div>
          </EditorProvider>
        </React.Fragment>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return { state };
};

const mapDispatchToProps = function (dispatch) {
  return {
    openEvent: (data, activeScreenName = null) => {
      return dispatch({ type: "OPEN_EVENT_MENU", data, activeScreenName });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateEditor);
